/**
 * Проверяет, не null или undefined ли параметр, и приводит его к типу T
 * Удобно использовать, например, в Array.prototype.filter
 */
export const notEmpty = <T>(data: T | null | undefined): data is T =>
  Boolean(data);
